// Import site styling
import './../scss/app.scss';

import prepareSliderEnhancement from './Components/slider.js';
prepareSliderEnhancement();

import prapareNumbedList from './Components/numbedList.js';
prapareNumbedList();

// Import and assign the Alpine function to the global window object
import Alpine from 'alpinejs';
window.Alpine = Alpine;

import pgoInit from './Pgo/app-pgo.js'
pgoInit();

import registerPetition from './Components/petition.js';
registerPetition(Alpine);

Alpine.start();

import prepareTextareaMaxLengthList from './Components/formTextareaLength.js';
prepareTextareaMaxLengthList();

import prepareFreeformFileUpload from './Components/freeformFileUpload.js';
prepareFreeformFileUpload();

import prepareSearchHighlight from './Components/searchHighlight.js';
prepareSearchHighlight();

import prepareNewsletterForm from './Components/newsletterForm.js';
prepareNewsletterForm();

// @see https://nystudio107.com/docs/vite/#entry-script-hmr
if (import.meta.hot) {
  import.meta.hot.accept(() => {
  });
}
